import { Button, Flex } from 'antd';
import { DateTime, WeekdayNumbers } from 'luxon';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { FORMAT_DATE, WEEKEND_DAYS } from '../const';
import { getStartOfWeek } from '../functions';
import { ComponentsDispatch, RootState } from '../store';
import { setterCalendar } from '../store/slices/calendarSlice';
import { DayWeekType } from '../types';

interface CalendarHeaderDayProps {
    typeDayWeek: DayWeekType;
    day: WeekdayNumbers;
    index: number;
}

const CalendarHeaderDay: React.FC<CalendarHeaderDayProps> = ({ typeDayWeek, day, index }) => {
    const dispatch = useDispatch<ComponentsDispatch>();

    const currentDate = useSelector<RootState, string>((state) => state.calendar.currentDate);

    const date = getStartOfWeek(DateTime.fromISO(currentDate)).plus({ day: index });

    const colorText = WEEKEND_DAYS.has(day) ? 'red' : 'black';

    const isActiveDay = currentDate === date.toFormat(FORMAT_DATE);

    return (
        <Flex
            justify={'center'}
            vertical
            align={'center'}
            style={{ padding: 10, opacity: typeDayWeek === 'day' && !isActiveDay ? 0.2 : 1 }}
        >
            <div style={{ paddingBottom: 5, color: colorText }}>{date.toFormat('ccc')}</div>
            <Button
                type={isActiveDay ? 'primary' : 'text'}
                shape="circle"
                style={{
                    color: isActiveDay ? 'white' : colorText,
                    fontSize: 25,
                    width: 45,
                    height: 45,
                }}
                onClick={() => {
                    dispatch(
                        setterCalendar({
                            currentDate: date.toFormat(FORMAT_DATE),
                        }),
                    );
                }}
            >
                {date.toFormat('dd')}
            </Button>
        </Flex>
    );
};

export default CalendarHeaderDay;
